module.exports = {
	"id": "SM",
	"name": "San Marino",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.055573,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.031756,
			"28": null,
			"29": 0.341377,
			"30": null,
			"31": null,
			"32": 0.063512,
			"33": 0.015878,
			"34": 0.071451,
			"35": null,
			"36": 0.047634,
			"37": null,
			"38": 0.015878,
			"39": 0.015878,
			"40": null,
			"41": null,
			"42": 0.039695,
			"43": 0.055573,
			"44": 0.015878,
			"45": 0.039695,
			"46": 0.007939,
			"47": 0.778022,
			"48": 0.063512,
			"49": 4.199731,
			"50": 0.047634,
			"51": 0.182597,
			"52": 0.277865,
			"53": 26.159005,
			"54": 8.391523,
			"55": 0.103207,
			"56": 0.015878,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.007939,
			"10": null,
			"11": null,
			"12": 0.698632,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.007939,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.015878,
			"22": null,
			"23": null,
			"24": 0.047634,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.174658,
			"34": null,
			"35": 0.007939,
			"36": null,
			"37": 0.047634,
			"38": 0.015878,
			"39": 0.023817,
			"40": 0.206414,
			"41": 0.023817,
			"42": 0.063512,
			"43": 0.150841,
			"44": 0.031756,
			"45": 0.142902,
			"46": 0.007939,
			"47": 0.516035,
			"48": 1.317874,
			"49": 15.044405,
			"50": 0.007939,
			"51": null,
			"52": 0.007939,
			"3.5": 0.277865,
			"3.6": 0.023817
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.007939,
			"37": null,
			"38": 0.111146,
			"39": null,
			"40": 0.206414,
			"41": 0.103207,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.039695
		},
		"safari": {
			"0": null,
			"4": 0.007939,
			"5": 0.047634,
			"6": null,
			"7": 0.031756,
			"8": 0.174658,
			"9": 0.420767,
			"10": 3.644001,
			"3.1": null,
			"3.2": null,
			"5.1": 0.325499,
			"6.1": 0.190536,
			"7.1": null,
			"9.1": 2.294371
		},
		"ios_saf": {
			"8": 0,
			"10": 4.55213464696,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.122674761345,
			"8.1-8.4": 0.226636423501,
			"9.0-9.2": 0.108120128643,
			"9.3": 1.64952503955
		},
		"android": {
			"3": 0,
			"4": 0.0152098604651,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00190123255814,
			"4.1": 0.0548641395349,
			"4.2-4.3": 0.137160348837,
			"4.4": 0.314518186047,
			"4.4.3-4.4.4": 0.317234232558
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 2.13422559011,
			"9": 0.262796434604,
			"10": 0.191124679712,
			"11": 5.14443929557,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00127918810644,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0000355330029567
		},
		"edge": {
			"12": 0.055573,
			"13": 0.666876,
			"14": 1.754519
		},
		"ie_mob": {
			"10": 0.163776929577,
			"11": 0.666806070423
		},
		"bb": {
			"7": 0.00360675,
			"10": null
		},
		"samsung": {
			"0": 2.704032
		},
		"and_uc": {
			"0": 0.043281
		},
		"op_mini": {
			"0": 0.0172342788906
		},
		"and_chr": {
			"0": 10.145119
		},
		"and_ff": {
			"0": 0.057708
		}
	},
	"total": 99.02566775
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SM.json
 ** module id = 647
 ** module chunks = 0
 **/